export default __webpack_public_path__ + "static/media/popcorn-pieces-03.76e79f64.png";